import AdvancedController from "./advanced-controller";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { debounce } from "../utils/utils";

gsap.registerPlugin(ScrollTrigger);
export default class TimelineController extends AdvancedController {
  static targets = ["timelineContainer", "line", "entries"];

  connect() {
    super.connect();
    if (this.hasEntriesTarget) {
      this.timelineHeight = 0;
      this.timeline = gsap.timeline({
        scrollTrigger: {
          start: "top 75%",
          trigger: this.timelineContainerTarget,
          end: "bottom 75%",
          scrub: 0.5,
        },
      });
      this.calcTimelinePosition();
      window.addEventListener(
        "resize",
        debounce(this.calcTimelinePosition.bind(this), 50)
      );
    }
  }

  calcTimelinePosition() {
    this.timelineHeights = 0;
    this.timelineTop =
      this.entriesTargets[0].offsetTop +
      this.entriesTargets[0].querySelector(".timeline__entry__badge").offsetTop +
      this.entriesTargets[0].querySelector(".timeline__entry__badge").offsetHeight / 2;
    this.timelineLeft =
      this.entriesTargets[0].querySelector(".timeline__entry__badge").offsetLeft +
      this.entriesTargets[0].querySelector(".timeline__entry__badge").offsetWidth / 2;

    this.timelineHeights = this.entriesTargets.map((el, index) => {
      if (index < this.entriesTargets.length - 1) {
        return (
          this.entriesTargets[index + 1].offsetTop +
          this.entriesTargets[index + 1].querySelector(".timeline__entry__badge").offsetTop +
          this.entriesTargets[index + 1].querySelector(".timeline__entry__badge").offsetHeight / 2 -
          this.timelineTop
        );
      }
    });

    gsap.fromTo(
      this.lineTarget,
      { opacity: 0 },
      {
        opacity: 1,
        top: this.timelineTop,
        left: this.timelineLeft,
        height: 0,
      }
    );
    this.setupScrollAnimation();
  }

  setupScrollAnimation() {
    this.timeline.clear();
    gsap.utils.toArray(this.entriesTargets).forEach((el, index) => {
      this.timeline.add(
        gsap.fromTo(
          el,
          {
            opacity: 0,
            y: "+=50px",
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.5,
          }
        ),
        "-=0.25"
      );
      this.timeline.add(
        gsap.fromTo(
          el.querySelector(".timeline__entry__badge"),
          {
            scale: 0,
            opacity: 0,
            y: "-=50px",
          },
          {
            scale: 1,
            opacity: 1,
            duration: 0.5,
            y: 0,
          }
        ),
        "-=0.5"
      );
      if (index < this.entriesTargets.length - 1) {
        this.timeline.add(
          gsap.to(this.lineTarget, {
            height: this.timelineHeights[index],
            duration: 1.5,
          })
        );
      }
    });
  }
}
